import React from "react";
import Blockquote from "components/Global/Module/Feed/Item/Blockquote";

export default item => {
  if (item.type === "confirmation") {
    return <Blockquote comment={item.content} />;
  }
  return item.content;
};
